export enum ClassificationParamsType {
  Document = 'document',
  Dossier = 'dossier'
}
